module.exports = __webpack_public_path__ + "static/img/products_page top img_mobile.5d627a5e.jpg";